import { Component, Input, OnInit, TemplateRef, ViewChild,Output,EventEmitter } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SubscriptService } from '../../../tool/service/header.service';
import { DatePipe } from '@angular/common'
import { HttpClient } from '@angular/common/http';
import {  NbDialogService } from '@nebular/theme';
import { CurrencyPipe} from '@angular/common';
import { ApiService } from '../../../tool/service/api.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-info-ord',
  templateUrl: './info-ord.component.html',
  styleUrls: ['./info-ord.component.scss']
})
export class InfoOrdComponent implements OnInit {

  @Output() emitList = new EventEmitter();
  @Output() emitClose = new EventEmitter();
  @Input() info: {
    moType: number; //目前編輯狀態 4.查看
    orgType: number; //1.訂單紀錄 2.發票紀錄   
    ordNo:string;
  };

  @ViewChild("Modal") Modal: TemplateRef<any>;
  modalRef = null; //談窗鉤子


  //基本資料
  USR_AccountInfo_ID: string;
  USR_EmployeeInfo_ID: string;
  USR_POSEmployeeInfo_ID: string;
  USR_AccountInfo: string;
  ORG_Company_ID: number;
  ORG_Store_ID: number;
  authChangeSub:any;
  ORD_Status_ID: number;

  orderDetail:any;
  adjustAccountList:any;

  refresh = {
    paymentList: true
  }

  constructor(
    private dialogService: NbDialogService,
    private http: HttpClient,
    private cookieService: CookieService,
    private apiSvr: ApiService,
  ) {
    this.apiSvr.checkReload()
    this.USR_AccountInfo_ID = this.cookieService.get('USR_AccountInfo_ID') ? 
      "USR_AccountInfo_ID_"+this.cookieService.get('USR_AccountInfo_ID') :
        this.cookieService.get('USR_POSEmployeeInfo_ID') ?  
          "USR_POSEmployeeInfo_ID"+this.cookieService.get('USR_POSEmployeeInfo_ID') : null;

    this.USR_POSEmployeeInfo_ID = this.cookieService.get('USR_POSEmployeeInfo_ID')
    this.USR_AccountInfo = this.cookieService.get('USR_AccountInfo_ID')

    this.USR_EmployeeInfo_ID = this.cookieService.get('USR_EmployeeInfo_ID')
    this.ORG_Company_ID = parseInt(this.cookieService.get('ORG_Company_ID'))
    let cookie_sid = this.cookieService.get('ORG_Store_ID')
    this.ORG_Store_ID= (cookie_sid && cookie_sid!='') ? parseInt(cookie_sid) : null
  }


  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.onOpen(this.info)

  }


  onOpen(info){
    this.getOrderDetail(info.ordNo) 
    this.GetAdjustAccountList(info.ordNo)

    this.modalRef = this.dialogService.open(this.Modal, {});
    this.modalRef.onClose.subscribe(result => {
      this.emitClose.emit(true);
    });
  }
  


  
  //取得詳細資料
  getOrderDetail(ordno) {

    this.http.get<any>('api/OrderManage/GetOrderDetail?ORDNo=' + ordno).subscribe({
      next: data => {
        this.orderDetail = _.assign(data.LIST[0])
        this.ORD_Status_ID = this.orderDetail.ORD_Status_ID
      },
      error: error => {
        console.error('There was an error!', error);
      }
    });

  }

  //取得調帳記錄
  GetAdjustAccountList(ordno) {

    this.http.post<any>('api/OrderManage/GetAdjustAccountList', {
      ORDNO: ordno,
    }).subscribe({
      next: data => {
        this.adjustAccountList= _.assign(data.LIST)
      },
      error: error => {
        console.error('There was an error!', error);
      }
    });

  }

  onClose(){
    this.modalRef.close()
  }

  
  @ViewChild('AdjustTransactionMoDOM', { static: false }) AdjustTransactionMoDOM;
  AdjustTransactionMoRef = null;
  
  AdjustTransactionMo = {
    info: {
      ORDNo: null,
    },
    data: {
      List: [],
    },
    adjustList: [] as Array<{ paymentKindId: string; amount: number }>,
    paymentList: [] as selectData2[], 

    onOpen: (orderDetail) => {
      let my = this.AdjustTransactionMo;
      
      my.info.ORDNo = orderDetail.ORDNo;
      my.paymentList = this.apiSvr.getPaymentList(0, orderDetail.ORG_Store_ID,()=>{
        this.refresh.paymentList = !this.refresh.paymentList
      }) 
      my.data.List = orderDetail.PaymentKindData.map(payment => ({
        SYS_PaymentKind_ID: payment.SYS_PaymentKind_ID,
        Name: payment.PaymentKindName,
        Cash: payment.Cash,
      }));
  
      my.adjustList = [];
      my.adjustList = orderDetail.PaymentKindData.map(payment => ({
        paymentKindId: payment.SYS_PaymentKind_ID,
        amount: payment.Cash,
      }));

      // 開啟模態視窗
      this.AdjustTransactionMoRef = this.dialogService.open(this.AdjustTransactionMoDOM, {});
    },

    addPayment: () => {
      let my = this.AdjustTransactionMo;
      my.adjustList.push({ paymentKindId: '', amount: 0 });
    },
  
    removePayment: (index: number) => {
      let my = this.AdjustTransactionMo;
      my.adjustList.splice(index, 1);
    },
    onSave: () => {
      let my = this.AdjustTransactionMo;
  
      let adjustAccountData: AdjustAccountData[] = my.adjustList.map((adjust, index) => {
        const originalData = my.data.List[index];
        
        if (originalData) {
          return {
            paymentID: adjust.paymentKindId,
            Cash: adjust.amount,
            old_PaymentID: originalData.SYS_PaymentKind_ID,
            Type: 1
          };
        } else {
          return {
            paymentID: adjust.paymentKindId,
            Cash: adjust.amount,
            old_PaymentID: null,
            Type: 2
          };
        }
      });
  
      if (my.data.List.length > my.adjustList.length) {
        for (let i = my.adjustList.length; i < my.data.List.length; i++) {
          adjustAccountData.push({
            old_PaymentID: my.data.List[i].SYS_PaymentKind_ID,
            Cash: 0,
            Type: 3
          });
        }
      }
  
      let req = {
        ORDNO: my.info.ORDNo,
        AdjustAccountXMLData: adjustAccountData,
        USR_AccountInfo_ID : this.USR_AccountInfo,
        USR_POSEmployeeInfo_ID : this.USR_POSEmployeeInfo_ID
      };
  
      this.http.post<any>('api/OrderManage/ModifyAdjustAccount', req).subscribe({
        next: (data) => {
          if (data.RESULT) {
            alert(data.RESULT);
          } else {
            this.AdjustTransactionMoRef.close();
            this.getOrderDetail(my.info.ORDNo);
            this.GetAdjustAccountList(my.info.ORDNo);
          }
        },
        error: (error) => {
          console.error('調整交易失敗:', error);
          alert('調整交易失敗');
        }
      });
    }
  };
}

class selectData2 {
  value: string;
  content: string;
}

interface AdjustAccountData {
  paymentID?: string | null; 
  Cash: number;
  old_PaymentID?: string | null;
  Type: 1 | 2 | 3;  //1變更,2新增,3移除
}